import { render, staticRenderFns } from "./Dynamic2.vue?vue&type=template&id=82842834&scoped=true&"
import script from "./Dynamic2.vue?vue&type=script&lang=js&"
export * from "./Dynamic2.vue?vue&type=script&lang=js&"
import style0 from "./Dynamic2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Dynamic2.vue?vue&type=style&index=1&id=82842834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82842834",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
